module.exports = __webpack_public_path__ + "static/media/SWSCRC1-08.f85af6d1.mp3";